/**************************************************
 * Nombre:       Producto_Imangenes
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import foto from '../../../../Recursos/tmp_producto.png'
import {useEffect, useState} from "react";

const Producto_Imangenes = ({item}) => {
    const [imgs, setImgs] = useState([])

    useEffect(() =>{

        if (item.imgs){
            setImgs(item.imgs)
        }

    },[item])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={item?.img} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={4}
                >

                    {imgs.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 3}}
                              sx={{justifyContent: 'flex-start', border: 1, borderColor: '#00000040', borderRadius: 1}}>
                            <img src={foto} width={'100%'} height={'auto'} style={{borderRadius: 10}}/>
                        </Grid>
                    ))}

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Producto_Imangenes

const items = [1, 2, 3, 4]